<template>
  <div class="home">
    <h1>Greenstep Hub Microservices</h1>
    <p>This is a purchase invoice approval application</p>
    <p class="version">Version: {{ appVersion }}</p>
    <template v-if="isLocalhost">
      <h2>Test instructions</h2>
      <p>To test this application, please go to <a href="/demotoken">Token generator page</a></p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const appVersion: string = '1.0.1';

const isLocalhost = computed(() => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
})
</script>